const prefix = "/coupon"
import { MenuTree } from "~/types/menu"

export const MenuCoupon: MenuTree = {
  home: {
    name: "Home",
    icon: "mdi-home",
    to: prefix,
  },
  coupons: {
    name: "Coupons",
    icon: "mdi-ticket",
    to: prefix + "/coupons",
  },
}
